import { render } from "./Rooms.vue?vue&type=template&id=0915d41e"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__